import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-input-file-preview',
    templateUrl: './input-file-preview.component.html',
    styleUrls: ['./input-file-preview.component.scss'],
    standalone: true,
    imports: [MatIcon]
})
export class InputFilePreviewComponent {
  @Input() itemFormIndex: number | undefined;
  @Output() removeAt = new EventEmitter<number>();
  protected item: File | undefined;

  @Input({ required: true }) set file(file: File) {
    this.item = file;
  }

  protected removeItem() {
    this.removeAt.emit(this.itemFormIndex);
  }
}
